export function hashCode(inputString) {
    for (var i = 0, hash = 0; i < inputString.length; i++)
        hash = Math.imul(31, hash) + inputString.charCodeAt(i) | 0;
    return hash;
}